import {React} from 'react';
import ReactECharts from 'echarts-for-react';  // or var ReactECharts = require('echarts-for-react');


// import the core library.
// Import the echarts core module, which provides the necessary interfaces for using echarts.
import * as echarts from 'echarts/core';
// Import charts, all with Chart suffix

import {
  LineChart,
  // BarChart,
  // PieChart,
  // ScatterChart,
  // RadarChart,
  // MapChart,
  // TreeChart,
  // TreemapChart,
  // GraphChart,
  // GaugeChart,adjustTop
  // FunnelChart,
  // ParallelChart,
  // SankeyChart,
  // BoxplotChart,
  // CandlestickChart,
  // EffectScatterChart,
  // LinesChart,
  // HeatmapChart,
  // PictorialBarChart,
  // ThemeRiverChart,
  // SunburstChart,
  // CustomChart,
} from 'echarts/charts';
// import components, all suffixed with Component
import {
  // GridSimpleComponent,
  GridComponent,
  // PolarComponent,
  // RadarComponent,
  // GeoComponent,
  // SingleAxisComponent,
  // ParallelComponent,
  // CalendarComponent,
  // GraphicComponent,
  // ToolboxComponent,
  TooltipComponent,
  // AxisPointerComponent,
  // BrushComponent,
  TitleComponent,
  // TimelineComponent,
  // MarkPointComponent,
  // MarkLineComponent,
  // MarkAreaComponent,
  // LegendComponent,
  // LegendScrollComponent,
  // LegendPlainComponent,
  // DataZoomComponent,
  // DataZoomInsideComponent,
  // DataZoomSliderComponent,
  // VisualMapComponent,
  // VisualMapContinuousComponent,
  // VisualMapPiecewiseComponent,
  // AriaComponent,
  // TransformComponent,
  // DatasetComponent,
} from 'echarts/components';
// Import renderer, note that introducing the CanvasRenderer or SVGRenderer is a required step
import {
  CanvasRenderer,
  // SVGRenderer,
} from 'echarts/renderers';

const LineGraph = (props) => {
  // Register the required components
  echarts.registerTheme('my_theme', {
    backgroundColor: '#f4cccc'
  });

  echarts.use(
    [TitleComponent, TooltipComponent, GridComponent,   LineChart,  CanvasRenderer]
  );
  

  var styleWidth = '100%';
  var styleleft = '10px';
  if(props?.adjustTop === 'popUp') {
    styleWidth = '110%'
    styleleft = '-12px'
  }
	const options = () =>(
        {
          grid: {
            left: 50,
            height: "50%",
            top: props?.adjustTop === 'popUp' ? '15%' : '27%'
           
          },
            xAxis: {
              type: 'category',
              data: props.data.time,
              scaleFontSize: 15,
              boundaryGap: false,
              axisTick: {
                show:false,
              },
              axisLabel: {
                textStyle: {
                    color: '#000000',
                    fontFamily:"Montserrat",
                    fontWeight: "normal",
                    fontSize:window.screen.width >= 1450 ?10:8,
                    padding:window.screen.width >= 1450 ?[0,0,0,30]:[0,0,0,5]
                    // padding: [0,50,0,50]
                }
              },
              
            },
            axisPointer: {
              triggerOn: 'click'
            },
            legend: {
              top: 0,
              bottom: 20,
          },
            yAxis: {
              type: 'value',
              name: 'kW',
              nameLocation: 'middle',
              nameGap: 32,
              nameRotate: 0,
              axisLabel: {
                textStyle: {
                    color: '#000000',
                    fontFamily:"Montserrat",
                    fontWeight: "normal",
                    fontSize:10,
                }
              },
             
              nameTextStyle: {
                fontFamily:"Montserrat",
                fontWeight: "normal",
                fontSize:10,
                color: '#000000',
              }
            },
            series: [
              {
                symbol:'none',
                cursor:'auto',
                data: props.data.balance,
                type: 'line',
               
              },
              
            ],
            visualMap: {
              show: false,
              left: 'right',
              min: 0,
              max: 1,
              inRange: {
                color: ['#5696AD', '#689730']
                // color: ['#00B5E2', '#689730']
              },
              text: ['>0', '<0'],
              calculable: true
            },
            scales: {
              x: {
                  ticks: {
                      font: {
                          size: 10,
                          family:'Montserrat'
                      }
                  }
              },
              y: {
                  ticks: {
                      font: {
                          size: 10,
                          family:'Montserrat'
                      }
                  }
              }                       
          }
          });

		return(
      <ReactECharts
      echarts={echarts}
      //option={this.getOption()}
      notMerge={true}
      lazyUpdate={true}
      theme={"theme_name"}
      //onChartReady={this.onChartReadyCallback}
      //onEvents={EventsDict}
      // style={{height: '230px', width: '100%', marginTop:'-55px'}}
      style={{height: '100%', width: styleWidth,top:'0px', left: styleleft,position:"absolute"}}
      opts={{renderer: 'svg'}} // use svg to render the chart.
      option={options()}
    />
		)
	
};

export default LineGraph;


